/* Copyright (c) 2020, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Injectable } from '@angular/core';
import { ReplaySubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class BrowserLeanModeService {
    private leanModeTransitionSub: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

    constructor() {}

    public get leanModeTransitionState(): Observable<boolean> {
        return this.leanModeTransitionSub.asObservable();
    }

    enableLeanMode() {
        this.leanModeTransitionSub.next(true);
    }

    disableLeanMode() {
        this.leanModeTransitionSub.next(false);
    }
}
